import { AuthProvider } from "ra-core";
import { ROLES, actionPermissions } from "shared/utils/resourcesPermision";
import { ENTRYPOINT, getCookie } from "../config/api";
import queryClient from "./client/main";


function triggerKeycloakLogin() {
  const currentUrl = window.location.href;
  const url = new URL(ENTRYPOINT + "/auth/login", window.location.origin);
  url.searchParams.set("redirect_uri", currentUrl);
  window.location.href = url.toString();
}

function getCurrentUser() {
  return queryClient.fetchQuery(
    ["users", "me"],
    async () => {
      const res = await fetch(ENTRYPOINT + "/users/me", {
        credentials: 'include',
        referrer: window.location.href
      });
      if (!res.ok) {
        return triggerKeycloakLogin();
      }
      return res.json();
    },
    { retry: false }
  );
}

const authProvider: AuthProvider = {
  login: async () => {
    triggerKeycloakLogin();
    return new Promise(() => { });
  },
  logout: async () => {
    const response = await fetch(ENTRYPOINT + '/auth/logout', {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": getCookie("csrf_token"),

      }),
      referrer: window.location.href,
      credentials: 'include',
    })
    if (!response.ok) {
      console.warn("Logout failed")
    }
    triggerKeycloakLogin()
    return new Promise(() => { });
  },
  checkAuth: async () => {
    try {
      await getCurrentUser();
    } catch {
      triggerKeycloakLogin();
      return new Promise(() => { });
    }
  },
  checkError: async (err: { status: any; response: { status: any } }) => {
    const status = err?.status || err?.response?.status;
    if ([401, 403].includes(status)) {
      await queryClient.removeQueries(['users', 'me']);
      triggerKeycloakLogin();
      return new Promise(() => { });
    }
    return Promise.resolve();
  },
  getIdentity: async () => {
    return await getCurrentUser()
      .then(user => ({
        id: user.id,
        role: { ...user.role, name: ROLES?.[user?.role?.id] },
        organization: user.organization,
        groups: user.groups,
      }))
    // return Promise.resolve(userIdentity);
  },
  getPermissions: async () => {
    return await getCurrentUser()
      .then((user) => ({
        role: { ...user.role, name: ROLES?.[user?.role?.id] },
        actions: actionPermissions[user?.role?.id]
      }))

  },
};

export default authProvider;
